import apiClient from '@u/apiClient'
import UpdateDiaryChiftInvoicingLinkController from '@/wayfinder/actions/App/Http/Controllers/Partner/ChiftInvoicing/UpdateDiaryChiftInvoicingLinkController'
import UpdateDiaryChiftInvoicingPaymentSyncController from '@/wayfinder/actions/App/Http/Controllers/Partner/ChiftInvoicing/UpdateDiaryChiftInvoicingPaymentSyncController'

export default {
  updateAccountingDiaryChiftInvoicingLink(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDiaryChiftInvoicingLinkController.put({
            accounting_diary: payload.id
          }),
          {
            enabled: payload.enabled
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateAccountingDiaryChiftInvoicingPaymentSync(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDiaryChiftInvoicingPaymentSyncController.put({
            accounting_diary: payload.id
          }),
          {
            enabled: payload.enabled
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
